import { Trophy, Search, Users } from 'lucide-react'
import { cn } from '../../lib/utils'

interface MobileBottomNavProps {
  activeTab: 'your-teams' | 'browse' | 'leaderboard'
  onTabChange: (tab: 'your-teams' | 'browse' | 'leaderboard') => void
  trackingMode: 'all-time' | 'trip-mode'
  showLeaderboard?: boolean
}

export function MobileBottomNav({
  activeTab,
  onTabChange,
  trackingMode,
  showLeaderboard = true
}: MobileBottomNavProps) {
  const tabs = [
    {
      id: 'your-teams' as const,
      label: trackingMode === 'all-time' ? 'Your Teams' : 'Trip Teams',
      icon: Trophy,
    },
    {
      id: 'browse' as const,
      label: 'Browse',
      icon: Search,
    },
    ...(showLeaderboard ? [{
      id: 'leaderboard' as const,
      label: 'Groups',
      icon: Users,
    }] : []),
  ]

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 safe-area-bottom">
      <div className="grid grid-cols-3 gap-0">
        {tabs.map((tab) => {
          const Icon = tab.icon
          const isActive = activeTab === tab.id

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={cn(
                'flex flex-col items-center justify-center py-3 px-2 min-h-[64px] transition-colors touch-manipulation active:bg-gray-100',
                isActive
                  ? 'text-[#42a5f5]'
                  : 'text-gray-600'
              )}
            >
              <Icon className={cn(
                'h-6 w-6 mb-1 transition-colors',
                isActive ? 'text-[#42a5f5]' : 'text-gray-500'
              )} />
              <span className={cn(
                'text-xs font-medium',
                isActive ? 'text-[#42a5f5]' : 'text-gray-600'
              )}>
                {tab.label}
              </span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}
